import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
    GET_RECENTLY_POSTED, GET_RECENTLY_POSTED_FETCH_DONE,
    GET_SKILLS, GET_SKILLS_FETCH_DONE, GET_SKILLS_FETCH_FAILED,
    GET_TOP_CATEGORIES, GET_JOB_CATEGORIES,
    GET_TOP_CATEGORIES_FETCH_DONE, GET_TOP_CITIES, GET_TOP_CITIES_FETCH_DONE, GET_JOB_CATEGORIES_FETCH_DONE
} from '../actions/actionTypes';
import axios from 'axios';
// import trending from '../data/cats.json';

// const apiUrl = `https://jsonplaceholder.typicode.com/users`;
const API_URL = process.env.REACT_APP_API_SERVICE;
function getTopCategories() {
    return axios.get(`${API_URL}/publicjobs/categories`, {
        headers: {
            'Content-Type': 'application/json',

        }
    }).then(response => response)
        .catch((error) => { throw error })
}

function getTopLocations() {
    return axios.get(`${API_URL}/publicjobs/locations`, {
        headers: {
            'Content-Type': 'application/json',

        }
    }).then(response => response)
        .catch((error) => { throw error })
}

function getSkills() {
    return axios.get(`${API_URL}/skills`, {
        headers: {
            'Content-Type': 'application/json',
        }
    }).then(response => response)
        .catch((error) => { throw error })
}

function getJobCategories() {
    return axios.get(`${API_URL}/jobs/jobcategories`, {
        headers: {
            'Content-Type': 'application/json',
        }
    }).then(response => response)
        .catch((error) => { throw error })
}

function getRecentJobs() {
    return axios.get(`${API_URL}/publicjobs/recentjobs/1`, {
        headers: {
            'Content-Type': 'application/json',
        }
    }).then(response => response)
        .catch((error) => { throw error })
}

function* fetchTopCategories(action) {
    try {
        const response = yield call(getTopCategories);
        yield put({ type: GET_TOP_CATEGORIES_FETCH_DONE, payload: response.data.data });
    } catch (e) {
        yield put({ type: 'GET_USERS_FAILED', message: e.message });
    }
}

function* fetchJobCategories(action) {
    try {
        const response = yield call(getJobCategories);
        console.log(response, "response yeild");
        yield put({ type: GET_JOB_CATEGORIES_FETCH_DONE, payload: response.data.data });
    } catch (e) {
        yield put({ type: 'GET_JOB_CATEGORIES_FETCH_FAILED', message: e.message });
    }
}

function* fetchRecentJobs(action) {
    try {
        const response = yield call(getRecentJobs);
        yield put({ type: GET_RECENTLY_POSTED_FETCH_DONE, payload: response.data.data });
        yield put({ type: 'SET_TOTAL_ACTIVE_JOBS', payload: response.data.count });
    } catch (e) {
        yield put({ type: 'GET_USERS_FAILED', message: e.message });
    }
}


function* fetchTopCities(action) {
    try {
        const response = yield call(getTopLocations);
        yield put({ type: GET_TOP_CITIES_FETCH_DONE, payload: response.data.data });
    } catch (e) {
        yield put({ type: 'GET_USERS_FAILED', message: e.message });
    }
}

function* fetchSkills(action) {
    try {
        const response = yield call(getSkills);
        yield put({ type: GET_SKILLS_FETCH_DONE, payload: response.data.data });
    } catch (e) {
        yield put({ type: GET_SKILLS_FETCH_FAILED, message: e.message });
    }
}

function* topFetchSagas() {
    yield all([
        yield takeLatest(GET_TOP_CATEGORIES, fetchTopCategories),
        yield takeLatest(GET_TOP_CITIES, fetchTopCities),
        yield takeLatest(GET_SKILLS, fetchSkills),
        yield takeLatest(GET_RECENTLY_POSTED, fetchRecentJobs),
        yield takeLatest(GET_JOB_CATEGORIES, fetchJobCategories),
    ]);
}

export default topFetchSagas;